import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 640"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m53.5 245.1 56.8-113.7c10.9-21.7 33-35.4 57.3-35.4h304.9c24.2 0 46.4 13.7 57.2 35.4l56.8 113.7c3.6 7.2 5.5 15.1 5.5 23.2 0 27.3-21.2 49.7-48 51.6V512c0 17.7-14.3 32-32 32s-32-14.3-32-32V320h-96v176c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V319.9c-26.8-1.9-48-24.3-48-51.6 0-8 1.9-16 5.5-23.2M160 320v112c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16V320z" }, null, -1)
  ]))]))
}
export default { render: render }